// extracted by mini-css-extract-plugin
export default {"root":"roles_header-module___root___af99c139","scrollWrapper":"roles_header-module___scrollWrapper___c2ba29e6","headersRow":"roles_header-module___headersRow___bf3f6404"};